// frontend/src/features/reports/lib/useEscapeKey.js
import { useEffect } from 'react';

/**
 * Call `handler` when Escape is pressed, while `enabled` is true.
 *
 * Document-level so it fires regardless of where focus sits (the report popup
 * has no focus trap, so focus may be on the search box, the date field, or the
 * body). Used to close the report-generation popup; gate it on the popup's open
 * state so the listener only exists while the dialog is up.
 *
 * `doc` names the document to listen on. The dialog also opens inside a report
 * window's own OS popup, whose key events never reach the opener's `document`;
 * that caller passes the popup document. Omit it for the main tab.
 */
export function useEscapeKey(handler, enabled = true, doc = null) {
  useEffect(() => {
    if (!enabled || typeof handler !== 'function') return undefined;
    const target = doc || document;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') handler(e);
    };
    target.addEventListener('keydown', onKeyDown);
    return () => target.removeEventListener('keydown', onKeyDown);
  }, [handler, enabled, doc]);
}
